/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetOrdersReportQueryResponse, GetOrdersReportQueryParams, GetOrdersReport400 } from '../entities/GetOrdersReport'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetOrdersReportUrl() {
  return `/orders/report` as const
}

/**
 * @description Получение отчета по заказам
 * @summary Получение отчета по заказам
 * {@link /orders/report}
 */
export async function getOrdersReport(params?: GetOrdersReportQueryParams, config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetOrdersReportQueryResponse, ResponseErrorConfig<GetOrdersReport400>, unknown>({
    method: 'GET',
    url: getGetOrdersReportUrl().toString(),
    params,
    ...requestConfig,
  })
  return res.data
}